import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Card, Flex, Button, TextContainer } from '@costar/theme-ui';
import React, { useRef } from 'react';
import { getResourceTransferListKey } from '../../common/culture-resource-key.esm.js';

var _excluded = ["resolveText", "onResetClick", "onApplyClick", "onCloseClick", "labels", "children", "secondaryModal"];
var resolveLabels = function resolveLabels(resolveText, labels) {
  var _ref = labels !== null && labels !== void 0 ? labels : {},
    title = _ref.title,
    reset = _ref.reset,
    cancel = _ref.cancel,
    apply = _ref.apply,
    descriptions = _ref.descriptions;
  return {
    titleLabel: title !== null && title !== void 0 ? title : resolveText('title', 'Modify Table Layout'),
    resetLabel: reset !== null && reset !== void 0 ? reset : resolveText('reset', 'Default Layout'),
    cancelLabel: cancel !== null && cancel !== void 0 ? cancel : resolveText('cancel', 'Cancel'),
    applyLabel: apply !== null && apply !== void 0 ? apply : resolveText('apply', 'Apply'),
    descriptionsText: descriptions !== null && descriptions !== void 0 ? descriptions : resolveText('descriptions', 'Select the columns you would like displayed in your result set.\r\n\r\nNote that the Market or Submarket column will always be present.')
  };
};
var MTLContainer = /*#__PURE__*/React.forwardRef(function MTLContainer(props, ref) {
  var _textContainerRef$cur;
  var _props$resolveText = props.resolveText,
    resolveText = _props$resolveText === void 0 ? function (key) {
      return key;
    } : _props$resolveText,
    onResetClick = props.onResetClick,
    onApplyClick = props.onApplyClick,
    onCloseClick = props.onCloseClick,
    labels = props.labels,
    childrenProp = props.children,
    _props$secondaryModal = props.secondaryModal,
    secondaryModal = _props$secondaryModal === void 0 ? null : _props$secondaryModal,
    rest = _objectWithoutProperties(props, _excluded);
  var _resolveLabels = resolveLabels(getResourceTransferListKey(resolveText), labels),
    titleLabel = _resolveLabels.titleLabel,
    resetLabel = _resolveLabels.resetLabel,
    cancelLabel = _resolveLabels.cancelLabel,
    applyLabel = _resolveLabels.applyLabel,
    descriptionsText = _resolveLabels.descriptionsText;
  var textContainerRef = useRef(null);
  var children = /*#__PURE__*/React.isValidElement(childrenProp) ? /*#__PURE__*/React.cloneElement(childrenProp, _objectSpread2(_objectSpread2({}, childrenProp.props), {}, {
    offsetHeight: (_textContainerRef$cur = textContainerRef.current) === null || _textContainerRef$cur === void 0 ? void 0 : _textContainerRef$cur.clientHeight
  })) : null;
  return /*#__PURE__*/React.createElement(Card.Card, _extends({
    useContext: true,
    variant: "card-modal",
    ref: ref,
    display: "flex",
    flexDirection: "column"
  }, rest), /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Card.Title, {
    ellipsis: true
  }, titleLabel), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end",
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "icon",
    icon: "close",
    iconSize: "xl",
    color: "neutral.dark",
    p: "0",
    onClick: onCloseClick
  }))), /*#__PURE__*/React.createElement(Card.Content, {
    display: "flex",
    flexDirection: "column",
    px: "xl",
    height: "100%",
    minHeight: 0
  }, /*#__PURE__*/React.createElement(TextContainer, {
    as: "span",
    ref: textContainerRef,
    fontSize: "sm",
    mb: "xl"
  }, descriptionsText), children, secondaryModal), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end",
    flex: "1",
    "automation-id": "csg-trl-btn-group-layout",
    gap: "md"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onResetClick,
    "automation-id": "csg-trl-btn-default"
  }, resetLabel), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onCloseClick,
    "automation-id": "csg-trl-btn-cancel"
  }, cancelLabel), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: onApplyClick,
    "automation-id": "csg-trl-btn-apply"
  }, applyLabel))));
});

export default MTLContainer;
//# sourceMappingURL=mtl-container.esm.js.map
